<template>
  <vs-popup :active.sync="popupActive" :title="$t(`ptos.${action}`)" @close="$emit('cancel')" class="holamundo">

    <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid, reset }">
      <form @submit.prevent="$emit(action, ptoData)">

        <date-picker :input-label="$t('ptos.table.start_date')" :name="$t('ptos.table.start_date')"
                     class="w-ful" rules="required"
                     :config="startDateConfig"
                     v-model="ptoData.start_date"/>

        <date-picker :input-label="$t('ptos.table.end_date')" :name="$t('ptos.table.end_date')"
                     class="w-ful" rules="required"
                     :config="endDateConfig"
                     v-model="ptoData.end_date"/>

        <base-textarea :input-label="$t('ptos.table.notes')"
                       class="w-full border-gray-400"
                       rows="7"
                       v-model="ptoData.notes"/>

        <div class="flex justify-center mt-5">
          <base-button :loading="loadingActions" button="filled" class="flex-1 mr-2" color="success" type="submit">
            {{ $t('ptos.saveAsDraft') }}
          </base-button>
          <base-button :loading="loadingActions" @click="$emit('send', ptoData)" button="filled" class="flex-1 ml-2" color="warning"
                       type="button">
            {{ $t('ptos.sendPtoRequest') }}
          </base-button>
        </div>
      </form>
    </ValidationObserver>

  </vs-popup>
</template>

<script>
  import DatePicker from "../DatePicker";
  import BaseButton from "../_base-button";
  import moment from "moment";

  export default {
    name: "PtoDetailsModal",
    components: {BaseButton, DatePicker},
    props: {
      ptoData: {
        type: Object,
        required: true
      },
      action: {
        required: true
      },
      loadingActions: {
        type: Boolean,
        default: false
      },
    },
    data: () => ({
      popupActive: false
    }),
    computed: {
      endDateConfig () {
        return {
          minDate: moment(this.ptoData.start_date).toDate(),
          dateFormat: "d M Y"
        }
      },
      startDateConfig () {
        return {
          minDate: moment().toDate(),
          maxDate: this.ptoData.end_date ? moment(this.ptoData.end_date).toDate() : null,
          dateFormat: "d M Y"
        }
      }
    },
    watch: {
      action (val) {
        this.$refs.validator.reset()
        this.popupActive = !!val;
      }
    }
  }
</script>

<style scoped>

</style>
